import React from 'react';

interface CustomIconProps {
  filled?: boolean;
  color?: string;
}

const DoubleTick: React.FC<CustomIconProps> = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1.995 11.4505L5.9475 14.4672L12.2942 7.21385L11.0392 6.11719L5.71916 12.1972L3.005 10.1255L1.995 11.4505ZM18.1275 7.21385L16.8725 6.11719L11.565 12.183L10.9375 11.6814L9.89583 12.983L11.7683 14.4814L18.1275 7.21385Z'
      fill='#FF7837'
    />
  </svg>
);

export default DoubleTick;
